import person1_1 from  './static/01anjianyuan2.png'
import person2_1 from  './static/02zhanwuyuan2.png'
import person3_1 from  './static/03liechesiji2.png'
import person4_1 from  './static/04baojieyuan2.png'
import person5_1 from  './static/05cheliangjianxiugong2.png'
import person6_1 from  './static/06jiechuwanggong2.png'
import person7_1 from  './static/07AFCjianxiugong2.png'
import person8_1 from  './static/08diaoduzhongxinpiaowu2.png'
import person9_1 from  './static/09tonghaojianxiugong2.png'
import person10_1 from  './static/10quanmeitikefu2.png'

const option2 = [
    {
        name: 'person1',
        img:person1_1
    },
    {
        name: 'person2',
        img:person2_1
    },

    {
        name: 'person3',
        ani: 'figerAni2',
        img:person3_1
    },

    {
        name: 'person4',
        img:person4_1
    },

    {
        name: 'person5',
        img:person5_1
    },

    {
        name: 'person6',
        img:person6_1
    },

    {
        name: 'person7',
        img:person7_1

    },

    {
        name: 'person8',
        img:person8_1
    },

    {
        name: 'person9',
        img:person9_1
    },

    {
        name: 'person10',
        img:person10_1
    },

]

export default option2;